import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { TestComponent } from './test/test.component';
import { LoginComponent } from './login/login.component';
import { MicrosoftCallbackComponent } from './login/microsoft-callback.component';


const routes: Routes = [
  {
    path: '',
    component: LoginComponent
  },
  // {
  //   path: 'microsoft/callback',
  //   component: MicrosoftCallbackComponent
  // }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
